// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__7T8WA","title":"FrontImage_title__aJQuW"};